module.exports = __webpack_public_path__ + "static/img/95042D_2_3_R_20200710_fit.7047d6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/95042D_2_3_R_20200710_fit.png
// module id = beHS
// module chunks = 0